import { RiCheckboxFill, RiCheckboxBlankLine } from "react-icons/ri";
import { useEffect, useState } from 'react'

export function CheckBox({ onClick, id, isChecked = false, disabled }) {
	const [checked, setChecked] = useState(isChecked)

	const handleClick = () => {
		setChecked(!checked)
		onClick({
			id: id,
			checked: !checked,
		})
	}

	useEffect(() => {
		setChecked(isChecked)
	},[isChecked])

	return (
		<button onClick={handleClick} className='tw-bg-transparent border border-0 tw-text-purple tw-flex tw-items-center tw-justify-center disabled:tw-text-gray-400' disabled={disabled}>
			{checked ? <RiCheckboxFill size={24} /> : <RiCheckboxBlankLine  size={24} />}
		</button>
	)
}
